import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const pointAddress = css`
  inline-size: calc(100% - ${spacing(11)}); // 100% - 88px
`

export const image = css`
  padding: ${spacing(1)};
`

export const truncatedText = css`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const dragger = css`
  touch-action: none;
  cursor: grab;
  inline-size: ${spacing(4.5)}; // 36px
  block-size: ${spacing(5)}; // 40px
`

export const icons = css`
  margin-inline-end: ${spacing(1.25)}; // 10px
`
